import { SiteContext } from '../../../common';
import { SiteSettingsScope } from '../../enums';
import { SiteSettings } from '../../models';
import { getSiteSettings } from './get-site-settings';

export const getFullSiteSettings = async (
  locale: string,
  siteContext: SiteContext
): Promise<SiteSettings> => {
  const settingScopes = [
    SiteSettingsScope.Ecom,
    SiteSettingsScope.Display,
    SiteSettingsScope.Sfcc,
    SiteSettingsScope.Authorization,
    SiteSettingsScope.MyJabra,
    SiteSettingsScope.Shipping,
    SiteSettingsScope.Returns,
    SiteSettingsScope.Cart,
  ];
  return getSiteSettings<SiteSettings>(locale, settingScopes, siteContext);
};
